import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en.json'; // 英文翻译文件
import zh from './zh.json'; // 中文翻译文件

// 注册国际化插件
Vue.use(VueI18n);

// 获取浏览器语言
const browserLanguage = navigator.language || navigator.userLanguage;
console.log(browserLanguage);
let defaultLocale = 'en'; // 默认语言设为英文

// 判断浏览器语言是否为中文或英文
if (browserLanguage.startsWith('zh')) {
  defaultLocale = 'zh';
} else if (browserLanguage.startsWith('en')) {
  defaultLocale = 'en';
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: defaultLocale, // 设置默认语言
  fallbackLocale: 'en',  // 回退语言为英文
  messages: {
    en,
    zh
  }
});

// 导出 i18n 实例
export default i18n;


// WEBPACK FOOTER //
// ./src/locales/i18n.js